import styles from "./page.module.css";
import LandingHeaderComponent from './landingHeaderComponent/landingHeaderComponent';
import Header from '../../components/header/Header';
import InfoSection from './infoSection/InfoSection';
import CalendarSection from './calendar/CalendarSection';
import FAQSection from './FAQSection/FAQSection';
import ContactSection from './contact/ContactSection';
import Footer from '../../components/footer/Footer';

export default function LandingPage() {

  const sections = [
    { id: "calendar-section", label: "Kalender" },
    { id: "faq-section", label: "FAQ" },
    { id: "contact-section", label: "Kontakt" },
  ];

  return (
    <div className={styles.page}>
      <Header>
        <LandingHeaderComponent sections={sections} />
      </Header>
      <main className={styles.main}>
        <section>
          <InfoSection />
        </section>
        <section id="calendar-section">
          <CalendarSection />
        </section>
        <section id="faq-section">
          <FAQSection />
        </section>
        <section id="contact-section">
          <ContactSection />
        </section>
      </main>
      <Footer />
    </div>
  );
}